import { config } from "../../config/config";
import { HttpServices } from "../../Helper";

export const GetAfterSalesKpi = async (body) => {
  try {
    const result = await HttpServices.get(
      `${config.server_address}/crmdfm/contacts/GetAfterSalesKpi`
    );
    return result;
  } catch (error) {
    throw error.response;
  }
};

export const FilterAfterSalesClient = async (body) => {
  try {
    const result = await HttpServices.post(
      `${config.server_address}/crmdfm/contacts/FilterAfterSalesClient`,
      body
    );
    return result;
  } catch (error) {
    throw error.response;
  }
};

export const GetAfterSalesTransactionByContactId = async (id) => {
  try {
    const result = await HttpServices.get(
      `${config.server_address}/crmdfm/contacts/GetAfterSalesUnitTransactionByContactId/${id}`
    );
    return result;
  } catch (error) {
    throw error.response;
  }
};

export const GetInquirActivity = async (body) => {
  try {
    const result = await HttpServices.post(
      `${config.server_address}/CrmDfm/Activities/GetInquirActivity`,
      body
    );
    return result;
  } catch (error) {
    throw error.response;
  }
};

export const CreateInquirActivity = async (body) => {
  try {
    const result = await HttpServices.post(
      `${config.server_address}/CrmDfm/Activities/CreateInquiryActivity`,
      body
    );
    return result;
  } catch (error) {
    throw error.response;
  }
};
export const GetInvoicesWithReceiptsByContact = async (body) => {
  try {
    const result = await HttpServices.post(
      `${config.server_address}/CrmDfm/Invoice/GetInvoicesWithReceiptsByContact/${body.contactId}`,
      body
    );
    return result;
  } catch (error) {
    throw error.response;
  }
};
export const BulkAssignAfterSales = async (body) => {
  try {
    const result = await HttpServices.post(
      `${config.server_address}/CrmDfm/Contacts/BulkAssignAfterSales`,
      body
    );
    return result;
  } catch (error) {
    throw error.response;
  }
};

export const GetUnitDocumentsByContactId = async (contactId) => {
  try {
    const result = await HttpServices.get(
      `${config.server_address}/CrmDfm/Unit/GetUnitDocumentsByContactId/${contactId}`
    );
    return result;
  } catch (error) {
    throw error.response;
  }
};
export const GetAfterSalesAgents = async ({ pageIndex, pageSize }) => {
  try {
    const result = await HttpServices.get(
      `${config.server_address}/CrmDfm/Agents/GetAfterSalesAgents/${pageIndex}/${pageSize}`
    );
    return result;
  } catch (error) {
    throw error.response;
  }
};
export const GetAfterSalesAgentById = async (id) => {
  try {
    const result = await HttpServices.get(
      `${config.server_address}/crmdfm/contacts/AfterSalesAssignee/${id}`
    );
    return result;
  } catch (error) {
    throw error.response;
  }
};

export const AddAfterSalesClientComment = async (body) => {
  try {
    const result = await HttpServices.post(
      `${config.server_address}/CrmDfm/Contacts/AddAfterSalesClientComment/${body.contactId}`,
      body
    );
    return result;
  } catch (error) {
    throw error.response;
  }
};

export const GetCommentsByContactId = async (contactId) => {
  try {
    const result = await HttpServices.get(
      `${config.server_address}/crmdfm/contacts/GetCommentsByContactId/${contactId}`
    );
    return result;
  } catch (error) {
    throw error.response;
  }
};
